function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 36,
  cy: 26,
  r: 1,
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10,21.92V34a4,4,0,0,0,4,4H38a4,4,0,0,0,4-4V18a4,4,0,0,0-4-4H21.93A8,8,0,1,0,8.4,20.72,8.58,8.58,0,0,0,10,21.92Zm2.8,1,.27,0A7.26,7.26,0,0,0,14,23a6.68,6.68,0,0,0,.78,0h.1l.17,0h0l.45-.07.21-.05.15,0h0l.36-.09.33-.11.11,0,.26-.1a3,3,0,0,0,.41-.18l.09,0h0l.17-.08.41-.23.19-.11,0,0c.14-.09.28-.18.41-.28l.17-.13a4.12,4.12,0,0,0,.4-.33l.15-.13c.13-.12.26-.24.38-.37l.12-.13c.12-.13.23-.25.34-.39H35a1,1,0,0,1,1,1v1a4,4,0,0,0,0,8v1a1,1,0,0,1-1,1H12V22.75l.15,0C12.37,22.83,12.58,22.87,12.8,22.9ZM34,26a2,2,0,0,1,2-2h4v4H36A2,2,0,0,1,34,26Zm6,8a2,2,0,0,1-2,2H14a2,2,0,0,1-2-2H35a3,3,0,0,0,3-3V30h2Zm0-16v4H38V21a3,3,0,0,0-3-3H21.41a3.39,3.39,0,0,0,.15-.41,1.15,1.15,0,0,0,.06-.17c0-.12.07-.25.11-.37l.09-.37.06-.34.06-.34H38A2,2,0,0,1,40,18ZM10.27,10.3A5.94,5.94,0,0,1,14,9a6,6,0,0,1,5.91,5A5.47,5.47,0,0,1,20,15a6,6,0,0,1-.83,3,5.07,5.07,0,0,1-.36.54l-.09.12a5.47,5.47,0,0,1-.45.51l0,0a5.87,5.87,0,0,1-.52.46l-.16.12a3.83,3.83,0,0,1-.42.28l-.19.12a5.93,5.93,0,0,1-.56.29l-.06,0c-.22.09-.44.16-.66.23l-.21,0-.52.11-.21,0A6.13,6.13,0,0,1,14,21a6.52,6.52,0,0,1-1.1-.1h0a7.14,7.14,0,0,1-1-.29h0a6.45,6.45,0,0,1-1-.47l0,0a5.69,5.69,0,0,1-.84-.62L9.8,19.3A6,6,0,0,1,8,15,6,6,0,0,1,10.27,10.3Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5,16H13v1.5a1,1,0,0,0,2,0V16h1.5a1,1,0,0,0,0-2H15V12.5a1,1,0,0,0-2,0V14H11.5a1,1,0,0,0,0,2Z",
  fill: "white"
});

function SvgAddFundsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Your Icons",
    id: "Your_Icons",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFundsIcon);
export default __webpack_public_path__ + "static/media/addFundsIcon.a3b51f99.svg";
export { ForwardRef as ReactComponent };